import React, { useEffect, useState, useCallback, useContext } from 'react';

import Title from '../../../components/Title';
import AuthContext from '../../../contexts/AuthContext';
import DeleteModal from './DeleteModal';
import {
  getContentsList,
  deleteContents,
  deletePublishedContents,
  getPublishedContentsList,
  isPublished,
  getContentsDetail,
  getUserDetail,
} from '../../../modules/NetworkFunction';
import MyContents from '../../../components/MyContents';
import Pagination from '../../../components/Pagination';
import usePaymentStatus from '../../../hooks/usePaymentStatus';
import SetContentsModal from '../ContentsPosting/SetContentsModal';
import ShopModeContext from '../../../contexts/ShopModeContext';
import { constrainedMemory } from 'process';
//import SetDesignManagement from './ContentDesignManagement';

function MyContentsList({ history }) {
  const { auth } = useContext(AuthContext);
  const token = auth;

  const { shopMode } = useContext(ShopModeContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [contentsList, setContentsList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [publishedContents, setPublishedContents] = useState([]);
  const [isPublishedContentsLoaded, setisPublishedContentsLoaded] =
    useState(false);
  const [isContentsLoaded, setisContentsLoaded] = useState(false);
  const [deleteNo, setDeleteNo] = useState();
  const [filter, setFilter] = useState('완성');
  const contentStates = ['완성', '미완성'];
  const itemPerPage = 4;
  const [modalOpen, setModalOpen] = useState(false);

  const { isPaid } = usePaymentStatus(token);

  const [codeCopyHash, setCodeCopyHash] = useState(false);
  const [codeCopyShopver, setCodeCopyShopver] = useState(false);

  const onClickFilterItem = (state) => {
    if (state === filter) {
      setFilter(null);
      setFilteredList(contentsList);
    } else {
      setFilter(state);
    }
  };

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const openDeleteModal = useCallback((contentsNo) => {
    //console.log('publishedContents : ', publishedContents);
    setDeleteNo(contentsNo);
    setDeleteModalOpen(true);
  });
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  useEffect(() => {
    setContentsList([]);
    setisContentsLoaded(false);
  }, [shopMode]);

  useEffect(
    () => {
      if (!isContentsLoaded) {
        getContentsList(
          null,
          (data) => {
            setContentsList(
              data.filter(
                (content) =>
                  (shopMode === 'cafe24' && content.shop === 'cafe24') ||
                  (shopMode === 'makeshop' && content.shop === 'makeshop')
              )
            );
            console.log(data);
          },
          setisContentsLoaded,
          (e) => {
            if (e) console.log(e);
          },
          token
        );
      }
    },
    [isContentsLoaded],
    [shopMode]
  );

  useEffect(() => {
    if (isContentsLoaded) {
      // if (filter === contentStates[0] && publishedContents !== null) {
      //   setFilteredList(
      //     contentsList.filter((v) => {
      //       return publishedContents.some(
      //         (content) =>
      //           content.contentsNo === v.contentsNo && content.isPublished
      //       );
      //     })
      //   );
      // } else
      if (filter === contentStates[0]) {
        setFilteredList(contentsList.filter((v) => v.completeYn === 1));
      } else if (filter === contentStates[1]) {
        setFilteredList(contentsList.filter((v) => v.completeYn === null));
      } else {
        setFilteredList(contentsList);
      }
      setCurrentPage(1);
    }
  }, [filter, contentsList, isContentsLoaded]);

  useEffect(() => {
    if (!isPublishedContentsLoaded) {
      getPublishedContentsList(
        {
          userNo: window.sessionStorage.getItem('userNo'),
          shop: shopMode,
          flag: true,
        },
        async (data) => {
          const isContentsPublished = await Promise.all(
            data.map(
              async (content) =>
                await isPublished(
                  {
                    userNo: window.sessionStorage.getItem('userNo'),
                    publishedContentNo: content.publishedContentNo,
                  },
                  (e) => {
                    console.error(e);
                  },
                  token
                )
            )
          );

          setPublishedContents(
            data.map((content, idx) => ({
              ...content,
              isPublished: isContentsPublished[idx],
            }))
          );
        },
        setisPublishedContentsLoaded,
        (e) => {
          if (e) console.log(e);
        },
        token
      );
    }
  }, [isPublishedContentsLoaded, token]);

  const contents = filteredList.map((info, idx) => {
    let start = (currentPage - 1) * itemPerPage;

    if (start <= idx && idx < start + itemPerPage) {
      return (
        <MyContents
          key={info.contentsNo}
          title={info.title}
          completeYn={info.completeYn}
          date={info.createDate}
          productCount={info.itemCount}
          thumbnail={info.thumbnail}
          openDeleteModal={() => {
            openDeleteModal(info.contentsNo);
          }}
          handleModifyContents={() => {
            handleModifyContents(info.contentsNo, info.videoURL, info.title, info.publishedContentNo);
          }}
          handleSetContents={() => {
            handleSetContents(info.contentsNo);
          }}
          isPosted={publishedContents.some(
            (contents) => contents.contentsNo === info.contentsNo
          )}
          isPcPublished={publishedContents.some(
            (contents) =>
              contents.mobileYn === 0 &&
              contents.contentsNo === info.contentsNo &&
              contents.isPublished
          )}
          isMobilePublished={publishedContents.some(
            (contents) =>
              contents.mobileYn === 1 &&
              contents.contentsNo === info.contentsNo &&
              contents.isPublished
          )}
          isPublishedContent={publishedContents.some(
            (contents) => contents.contentsNo === info.contentsNo
          )}
          handleModifyDesign={() => {
            handleModifyDesign(info.contentsNo);
          }}
          handleCodeCopy={() => {
            handleCodeCopy(info.contentsNo);
            openModal();
          }}
        />
      );
    }
  });

  const handleCodeCopy = (contentsN) => {
    const contents = publishedContents.filter(
      (content) => content.contentsNo === contentsN
    );
    //console.log(contents[0].hash)

    setCodeCopyHash(contents[0].hash);
    setCodeCopyShopver(contents[0].mobileYn ? 'mobile' : 'pc');
  };

  const handleModifyContents = (contentsNo, videoURL, title, publishedContentNo) => {
    history.push({
      pathname: '/mypage/contents-making/contents-modal/image-regist',
      state: {
        videoURL,
        contentsNo,
        title,
        isModify: true,
        publishedContentNo
      },
    });
  };

  const handleModifyDesign = (contentsNo) => {
    const publishedContent = publishedContents.filter(
      (content) => content.contentsNo === contentsNo
    );
    const isMobile = publishedContent.mobileYn;

    history.push({
      pathname: '/mypage/contents-management',
      state: {
        contentsNo,
        isMobile,
        publishedContents: publishedContent,
        isModify: true,
      },
    });
  };

  const handleDeleteContents = (contentsNo) => {
    let contents = { contentsNo: contentsNo };

    // contentsNo가 publishedContents의 요소 안에 있으면 delete 안함
    // 게시된 콘텐츠이기 때문에 삭제가 불가능합니다 라고 알림
    if (
      publishedContents.find((v) => v.contentsNo === contentsNo) !== undefined
    ) {
      alert('게시된 콘텐츠는 삭제가 불가능합니다.');
      closeDeleteModal();
      return;
    }

    deleteContents(
      contents,
      () => {
        setContentsList(
          contentsList.filter((c) => c.contentsNo !== contentsNo)
        );
      },
      () => {},
      (e) => {
        if (e) console.log(e);
      },
      token
    );

    if (
      publishedContents.find((v) => v.contentsNo === contentsNo) !== undefined
    ) {
      // 게시된 콘텐츠에 있으면 게시된 콘텐츠도 삭제를 해야함!
      let findContent = publishedContents.filter(
        (v) => v.contentsNo === contentsNo
      );
      findContent.forEach((item) => {
        deletePublishedContents(
          {
            contentsNo: item.contentsNo,
            mobileYn: item.mobileYn,
          },
          () => {
            setPublishedContents((prev) =>
              prev.filter((v) => v.contentsNo !== item.contentsNo)
            );
          },
          (error) => {
            console.log(error);
          },
          token
        );
      });
    }

    closeDeleteModal();
  };

  const handleManageContents = (
    contentsNo,
    title,
    productCount,
    thumbnail,
    style
  ) => {
    const publishedContent = publishedContents.filter(
      (content) => content.contentsNo === contentsNo
    );
    const isMobile = publishedContent.mobileYn;
    console.log(title, productCount, thumbnail, style);

    history.push({
      pathname: '/mypage/post-content',
      state: {
        contentsNo,
        isMobile,
        publishedContents: publishedContent,
        isModify: true,
        title,
        productCount,
        thumbnail,
        style,
      },
    });
  };

  const handleSetContents = (contentsNo) => {
    // 쇼핑몰에 배치된 모바일 콘텐츠 개수
    const publishedMobileContentsCount = publishedContents.filter(
      (c) => c.mobileYn === 1 && c.isPublished
    ).length;

    // 쇼핑몰에 배치된 PC 콘텐츠 개수
    const publishedPCContentsCount = publishedContents.filter(
      (c) => c.mobileYn === 0 && c.isPublished
    ).length;

    const canPublish =
      isPaid ||
      publishedMobileContentsCount === 0 ||
      publishedPCContentsCount === 0;

    console.log('개숱', publishedMobileContentsCount, publishedPCContentsCount);

    if (!canPublish) {
      alert(
        '무료 요금제는 PC와 모바일 각각 1개의 콘텐츠를 노출할 수 있습니다.'
      );
      return;
    }

    // published_content에 있지만 isPublished가 false인(배치 전) 콘텐츠 -> published_content 정보 넘겨주기
    history.push({
      pathname: '/mypage/content-posting-setting',
      state: {
        publishedMobileContentsCount,
        publishedPCContentsCount,
        contentsNo,
        isModify: false,
        isMobile: isPaid
          ? false
          : publishedMobileContentsCount === 0 && publishedPCContentsCount >= 1,
        publishedContents: publishedContents.filter(
          (content) => content.contentsNo === contentsNo
        ),
      },
    });
  };

  const Push = () => {
    history.push('/mypage/contents-making/contents-modal/content-regist');
  };

  const Publish = () => {
    if (contentsList.length === 0) {
      alert('등록된 콘텐츠가 없습니다. 콘텐츠를 등록해주세요.');
    } else {
      history.push({
        pathname: '/mypage/contents-management',
        state: {
          isModify: false,
        },
      });
    }
  };

  const buttonStyles = {
    default: {
      borderRadius: 20,
      fontSize: 16,
      cursor: 'pointer',
      padding: '4px 12px',
    },
    outline: {
      color: '#ccc',
      borderWidth: 1,
      borderColor: '#B5B5B5',
      borderStyle: 'solid',
    },
    fill: {
      color: 'white',
      backgroundColor: '#FFB600',
    },
  };

  const Empty = () => (
    <div
      style={{
        backgroundColor: '#e7e7e7',
        borderRadius: 20,
        display: 'flex',
        aligncontents: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: 788,
        height: 454,
        alignItems: 'center',
        marginTop: 30,
      }}
    >
      <img
        src="/icons/ic-face.png"
        style={{ width: 146, height: 146, marginBottom: 10 }}
      />
      <p style={{ marginBottom: 10, color: '#848484', fontSize: 22 }}>
        등록된 콘텐츠가 없습니다.
      </p>
      <b
        style={{ color: '#FF7A00', fontSize: 18, cursor: 'pointer' }}
        onClick={Push}
      >
        콘텐츠 등록하러 가기 &gt;{' '}
      </b>
    </div>
  );

  return (
    <div style={{ paddingBottom: 40 }}>
      <Title title="내 콘텐츠 목록" />
      <div
        style={{
          display: 'flex',
          gap: 12,
        }}
      >
        {contentStates.map((state) => {
          return (
            <div
              key={state}
              style={{
                ...buttonStyles.default,
                ...(filter === state
                  ? buttonStyles.fill
                  : buttonStyles.outline),
              }}
              onClick={() => onClickFilterItem(state)}
            >
              {state}
            </div>
          );
        })}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          aligncontents: 'center',
          height: 480,
        }}
      >
        <div
          style={{
            width: 788,
            display: 'flex',
            marginTop: 30,
            flexWrap: 'wrap',
            gap: 20,
          }}
        >
          {filteredList.length === 0 ? <Empty /> : contents}
        </div>
      </div>
      {filteredList.length > 0 && (
        <p
          style={{
            color: '#848484',
            fontSize: 12,
            fontWeight: 500,
            marginTop: 12,
          }}
        >
          * 배치 완료된 콘텐츠만 디자인 테마 수정이 가능합니다.
        </p>
      )}
      <div
        style={{
          position: 'absolute',
          bottom: 70,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <Pagination
          itemsPerPage={itemPerPage}
          totalItems={filteredList.length}
          paginate={setCurrentPage}
          currentPage={currentPage}
        />
      </div>

      <DeleteModal
        open={isDeleteModalOpen}
        close={closeDeleteModal}
        deleteContents={handleDeleteContents}
        contentsNo={deleteNo}
      ></DeleteModal>

      <SetContentsModal
        open={modalOpen}
        close={closeModal}
        version={codeCopyShopver}
        hash={codeCopyHash}
      ></SetContentsModal>
    </div>
  );
}

export default MyContentsList;
